'use client'

import { ReactNode } from 'react'

import { SessionProvider, useSession } from 'next-auth/react'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'
import { CookiesProvider } from 'react-cookie'

import { DataProviderProvider, useDataProvider } from '@/shared/contexts/DataProvider'
import { api } from '@/shared/services/api'
import { Toaster } from '@/shared/ui/sonner'

import { QueryProvider } from './QueryProvider'

interface AppProvidersProps {
  children: ReactNode
}

function SessionAwareProviders({ children }: { children: ReactNode }) {
  const { data: session } = useSession()
  const dataProvider = useDataProvider('', api)

  return (
    <QueryProvider session={session}>
      <DataProviderProvider dataProvider={dataProvider}>
        {children}
      </DataProviderProvider>
    </QueryProvider>
  )
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <CookiesProvider>
      <NuqsAdapter>
        <SessionProvider basePath="/api/auth">
          <SessionAwareProviders>{children}</SessionAwareProviders>
        </SessionProvider>
      </NuqsAdapter>
      <Toaster />
    </CookiesProvider>
  )
}
